module.exports = __webpack_public_path__ + "screen.0f703119.png";